import React, { useState,  useEffect } from 'react';
import styled from 'styled-components';
import ReactPageScroller from 'react-page-scroller';
import {mediaQueries} from "../shared/config";
import Gallery from "./Gallery";
import NavHeader from './NavHeaderForSlideshow';
import GifLandingPage from './GifLandingPage';

const Container = styled("div")`
  width: 100%;
  height: 100vh;
  background-image: url(${(props) => props.landing_image});
  background-position: center;
  background-size: cover;
  object-fit: cover;
  overflow: hidden;
  position: relative;
  
  ${mediaQueries.mobile} {
    height: 60vh;
  }
`;

const TextContainer = styled.div`
    position: relative;
    height: 50%;
    width: 100%;
    padding: 20px 0;
    /* display: flex;
    justify-content: center; */
    background: linear-gradient(180deg, #F2D851 0%, #FAC390 50.52%, #FFB5B5 100%);
`
const TextBox = styled.div`
    position: relative;
    border: 1px solid #000000;
    box-sizing: border-box;
    margin: 20px auto;
    height: auto;
    width: 60%;
    padding: 3vw 3vw;
    /* top: 50%;
    left: 50%; */
    /* transform: translate(-50%, -50%); */
    ${mediaQueries.mobile} {
    width:80%;
    padding: 30px 30px;
  }
`

const Title = styled.div`
    font-family: 'Bebas Neue', cursive;
    /* border: 1px solid #000000; */
    text-transform: uppercase;
    font-size: 4vw;
    margin-bottom: 2vw;

    ${mediaQueries.mobile} {
    font-size: 30px;
  }
`
const Paragraph = styled.div`
    font-family: 'Karla', sans-serif;
    margin-bottom: 1vw;
    ${mediaQueries.mobile} {
    margin-bottom: 20px;
  }
`
const GalleryContainer = styled.div`
    position:relative;
`

export default function Slideshow(props){


    return(
        <>
        <NavHeader/>
            {props.data &&
            <>
            {props.data.year_in_review.map(block=> {
                switch(block.type){
                    case 'box':
                        return(
                            <TextContainer>
                                <TextBox>
                                <Title>Year in review</Title>
                                    {block.content.map((content,index)=>{
                                        return(
                                            <Paragraph>{content.paragraph}</Paragraph>
                                        )
                                    })}
                                </TextBox>
                            </TextContainer>
                        )
                    case 'gallery':
                        return(
                            <GalleryContainer>
                                {/* <ReactPageScroller> */}
                                    {block.content.map((content, index) => {
                                        return(
                                            <div key = {index}>
                                                <Gallery image={content.image} 
                                                date={content.image_date}
                                                caption={content.image_caption}
                                                credit={content.image_credit}/>
                                            </div>
                                        )
                                    })}
                                {/* </ReactPageScroller> */}
                            </GalleryContainer>
                        )
                    default:
                        console.log("hello");
                }        
            })}

            </>
            }
        </>
    
    )
    
}

